// Build-time platform flag for the Capacitor (mobile) bundle — set via
// `vite build --mode mobile` (.env.mobile). Statically replaced, so the web
// build keeps IS_NATIVE=false as a constant and all native-only branches are
// dead-code-eliminated (and vice versa: purchase UI never ships in the app).
//
// Two things hang off this flag:
//  * API absolutization — the bundled app runs from the WebView's local origin
//    (https://localhost), so the SPA's relative API paths must point at prod.
//    Requests go through CapacitorHttp (native layer), so no CORS applies and
//    the Flask session cookie lives in the native cookie jar.
//  * Consumption-only storefront — Google Play billing policy: the Android app
//    must not expose the web checkout (/billing) or any top-up CTA. Balances
//    may be shown; purchases happen on the website only.
export const IS_NATIVE = import.meta.env.VITE_NATIVE === '1'

export const API_BASE: string = IS_NATIVE ? (import.meta.env.VITE_API_BASE ?? 'https://edimi.ai') : ''

/** Absolutize a backend path for the native app; identity on the web. */
export function apiUrl(path: string): string {
  return API_BASE + path
}
